import React from "react"
import Select from "react-select"
import makeAnimated from "react-select/animated"
import { connectField, filterDOMProps } from "uniforms"
import { AGE_RANGES, AGE_RANGE_DB_MAPPING } from "../../../util/ageRanges"

const animatedComponents = makeAnimated()

const AgeRangeField = ({
  disabled,
  id,
  inputRef,
  label,
  name,
  onChange,
  placeholder = "Select age range(s)...",
  value = [],
  className = "input-row",
  isRequired = false,
  ...props
}) => {
  // Ensure value is always an array
  const safeValue = Array.isArray(value) ? value : []
  const [menuIsOpen, setMenuIsOpen] = React.useState(false)
  // Create options from the age ranges
  const ageRangeOptions = Object.entries(AGE_RANGES).map(([key, displayLabel]) => ({
    value: AGE_RANGE_DB_MAPPING[key],
    label: displayLabel,
  }))

  // Add "All Ages" option at the top
  const allAgesOption = { value: "__ALL_AGES__", label: "All Ages" }
  const options = [allAgesOption, ...ageRangeOptions]

  // Check if all age ranges are selected (for "All Ages" state)
  const allAgeRangeValues = Object.values(AGE_RANGE_DB_MAPPING)
  const isAllAgesSelected = safeValue.length > 0 && allAgeRangeValues.every(val => safeValue.includes(val))

  // Convert current values to react-select v1/v2 format
  const selectedOptions = []

  // Add "All Ages" if all individual ranges are selected
  if (isAllAgesSelected) {
    selectedOptions.push(allAgesOption)
  }

  // Add individual age range options
  if (safeValue.length > 0) {
    safeValue.forEach(val => {
      const option = ageRangeOptions.find(opt => opt.value === val)
      if (option) {
        selectedOptions.push(option)
      }
    })
  }

  return (
    <section className={`${className} ${isRequired ? "isRequired" : ""}`} {...filterDOMProps(props)}>
      {label && <label htmlFor={id}>{label || "Age Range"}</label>}

      <Select
        id={id}
        name={name}
        ref={inputRef}
        disabled={disabled}
        placeholder={placeholder}
        value={selectedOptions}
        classNamePrefix="cl-select"
        styles={{
          input: provided => ({
            ...provided,
            border: "none",
            padding: 0,
            margin: 0,
            boxShadow: "none",
            background: "transparent",
          }),
          container: (provided) => ({
            ...provided,
            maxWidth: '82%',
            width: '82%'
          })
        }}
        onChange={v => {
          // Handle "All Ages" logic
          const selectedValues = v || []
          const hasAllAges = selectedValues.some(opt => opt.value === "__ALL_AGES__")
          const individualRanges = selectedValues.filter(opt => opt.value !== "__ALL_AGES__")

          let finalValues = []

          if (hasAllAges) {
            // Selecting "All Ages" forces all buckets to be selected
            finalValues = allAgeRangeValues
            setMenuIsOpen(false)
          } else {
            // Only individual ranges selected
            finalValues = individualRanges.map(opt => opt.value)
          }

          onChange(finalValues)
        }}
        options={options}
        isMulti={true}
        components={animatedComponents}
        menuIsOpen={menuIsOpen}
        onMenuOpen={() => setMenuIsOpen(true)}
        onMenuClose={() => setMenuIsOpen(false)}
        closeMenuOnSelect={false}
        hideSelectedOptions={false}
        backspaceRemovesValue={true}
        escapeClearsValue={false}
        isClearable={true}
        isSearchable={false}
      />
    </section>
  )
}

export default connectField(AgeRangeField)
